module.exports = __webpack_public_path__ + "static/media/pioneerGS.1cdeb94b.jpg";